import React from 'react';
import Footer from '../LayoutComponents/Footer';
import Header from '../LayoutComponents/Header';
import Banner from '../CommonComponents/Banner';

const PrivacyPolicy = () => {
  return (
    <>
    <Header/>
      <Banner 
        title="Privacy Policy"
        customHeight={true}
        textBlack={true}
      />

      <section className="section zigzag-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p><span style={{ fontWeight: 400 }}>Effective Date: 29 January 2025</span></p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  cloudmingle ("we," "us," "our") is committed to protecting your privacy. 
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your 
                  information when you visit our website [cloudmingle.site] (the "Site"). 
                  Please read this privacy policy carefully. If you do not agree with the terms 
                  of this privacy policy, please do not access the Site.
                </span>
              </p>
              
              <ol>
                <li><strong> Information We Collect</strong></li>
              </ol>
              <ul>
                <li style={{ fontWeight: 400 }}>
                  <strong>Personal Data:</strong>
                  <span style={{ fontWeight: 400 }}> We may collect personally identifiable information, such as 
                  your name, email address, and other contact details, when you register on our Site, 
                  subscribe to our newsletter, or otherwise communicate with us.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Usage Data:</strong>
                  <span style={{ fontWeight: 400 }}> We may collect information about your interactions with 
                  our Site, including the pages you visit, the links you click, and other actions you take.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Device Data:</strong>
                  <span style={{ fontWeight: 400 }}> We may collect information about your device, including IP 
                  address, browser type, operating system, and device identifiers.</span>
                </li>
              </ul>
              
              <ol start="2">
                <li><strong> How We Use Your Information</strong></li>
              </ol>
              <ul>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To provide, operate, and maintain our Site.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To improve, personalize, and expand our Site.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To understand and analyze how you use our Site.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To communicate with you, including customer service, 
                  updates, and promotional materials.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To process your transactions and manage your orders.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>To find and prevent fraud.</span>
                </li>
              </ul>
              
              <ol start="3">
                <li>
                  <strong> Sharing Your Information</strong>
                  <span style={{ fontWeight: 400 }}> We do not sell, trade, or otherwise transfer your personal 
                  information to outside parties except as described below:</span>
                </li>
              </ol>
              <ul>
                <li style={{ fontWeight: 400 }}>
                  <strong>Service Providers:</strong>
                  <span style={{ fontWeight: 400 }}> We may share your information with third-party service 
                  providers who perform services on our behalf, such as hosting, data analysis, payment processing, 
                  and customer service.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Business Transfers:</strong>
                  <span style={{ fontWeight: 400 }}> If we are involved in a merger, acquisition, or asset sale, 
                  your information may be transferred as part of that transaction.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <strong>Legal Requirements:</strong>
                  <span style={{ fontWeight: 400 }}> We may disclose your information if required to do so by law 
                  or in response to valid requests by public authorities.</span>
                </li>
              </ul>
              
              <ol start="4">
                <li>
                  <strong> Security of Your Information</strong>
                  <span style={{ fontWeight: 400 }}> We use administrative, technical, and physical security 
                  measures to help protect your personal information. However, no electronic transmission over 
                  the Internet or information storage technology can be guaranteed to be 100% secure.</span>
                </li>
                <li>
                  <strong> Your Data Protection Rights</strong>
                  <span style={{ fontWeight: 400 }}> Depending on your location, you may have the following 
                  rights regarding your personal information:</span>
                </li>
              </ol>
              <ul>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to access – You have the right to request copies 
                  of your personal information.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to rectification – You have the right to request 
                  that we correct any information you believe is inaccurate or complete information you believe 
                  is incomplete.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to erasure – You have the right to request that 
                  we erase your personal information, under certain conditions.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to restrict processing – You have the right to 
                  request that we restrict the processing of your personal information, under certain conditions.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to object to processing – You have the right to 
                  object to our processing of your personal information, under certain conditions.</span>
                </li>
                <li style={{ fontWeight: 400 }}>
                  <span style={{ fontWeight: 400 }}>The right to data portability – You have the right to request 
                  that we transfer the data that we have collected to another organization, or directly to you, 
                  under certain conditions.</span>
                </li>
              </ul>
              
              <ol start="6">
                <li>
                  <strong> Changes to This Privacy Policy</strong>
                  <span style={{ fontWeight: 400 }}> We may update our Privacy Policy from time to time. We will 
                  notify you of any changes by posting the new Privacy Policy on this page. You are advised to 
                  review this Privacy Policy periodically for any changes.</span>
                </li>
              </ol>
              
              <p>
                <strong>7. Contact Us</strong>
                <span style={{ fontWeight: 400 }}> If you have any questions about this Privacy Policy, please 
                contact us at: <a href="mailto:info@cloudmingle.site">info@cloudmingle.site</a></span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;